/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { BASE_URL, IMAGE_PATHS } from '../../../../constants/paths.constants';
import { poslumaDarkBlue, universalStyles } from '../../../../app/theme';
import FindingsPanel from '../../../micro/FindingsPanel/FindingsPanel';

const useStyles = makeStyles(() => ({
  ...universalStyles,
  headerImage: {
    display: 'block',
    width: '100%',
  },
  heading: {
    paddingTop: 30,
  },
  lymphNodeHeading: {
    paddingTop: 30,
    marginBottom: -30,
  },
  reviewFindingsText: {
    color: poslumaDarkBlue,
    paddingTop: 20,
  },
  image: {
    width: '80%',
    height: 'auto',
    marginLeft: 90,
    marginRight: 90,
    padding: '20px 0 20px 0',
  },
}));

const InterpretationPage14 = (): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.poslumaBox}>
        <img
          className={classes.headerImage}
          src={`${BASE_URL}${IMAGE_PATHS.STEPS[2].INTERPRETATION_STEP_3.path}`}
          alt={`${IMAGE_PATHS.STEPS[2].INTERPRETATION_STEP_3.alt}`}
        />
        <div className={classes.whiteBox}>
          <Typography variant="h2">STEP 3:</Typography>
          <Typography variant="h3">Exclude Incidental Uptake and Variants</Typography>
          <Typography variant="h4" className={classes.heading}>
            Cervical Ganglion
          </Typography>
          <ul className={classes.poslumaList}>
            <li>Physiologic uptake of POSLUMA in cervical ganglia (blue arrows)</li>
            <li>Not to be mistaken for lymph node</li>
            <li>Negative lesion</li>
          </ul>
          <Typography variant="body1" className={classes.reviewFindingsText}>
            <strong>See arrows for the location of the lesion and review findings</strong>
          </Typography>
          <img
            className={classes.image}
            src={`${BASE_URL}${IMAGE_PATHS.CERVICAL_GANGLION_BLUE_ARROWS.path}`}
            alt={`${IMAGE_PATHS.CERVICAL_GANGLION_BLUE_ARROWS.alt}`}
          />
          <Typography className={classes.lymphNodeHeading} variant="h4">
            Physiologic Uptake of POSLUMA in Lymph Nodes
          </Typography>
          <FindingsPanel
            trainingId={2}
            module="poslumaInterpretation"
            page={14}
            // setNextDisabledFindings={setNextDisabledFindings}
          />
        </div>
      </div>
    </>
  );
};

export default InterpretationPage14;
